import React, { Component } from "react";
import PropTypes from "prop-types";
import VolunteersStatsTableController from "./volunteers-stats-table-controller";
import { WithPromises } from "../contexts/api-context";
import { Loading, EmptyStateMessage } from "@evertrue/et-components";
import IsMobileContext, { IsMobileProvider } from "../contexts/is-mobile-context";

// This component calls and endpoint via warmAnalyticsData, which computes the data
// and writes it to ES, so we block rendering the VolunteerStatsTable until this has been completed
class VolunteerStatsTableWrapper extends Component {
  static propTypes = {
    pool: PropTypes.object.isRequired,
    promises: PropTypes.object.isRequired,
  };

  static defaultProps = {
    pool: {},
  };

  state = {
    loading: true,
    error: false,
    last_updated_at: null,
  };

  is_mounted = false;

  componentDidMount() {
    this.is_mounted = true;
    this.props.promises
      .warmAnalyticsData({ poolId: this.props.pool.id })
      .then(resp => {
        if (this.is_mounted) {
          this.setState({ loading: false, last_updated_at: resp.last_updated_at });
        }
      })
      .catch(e => {
        if (this.is_mounted) {
          this.setState({ error: true, loading: false });
        }
      });
  }

  componentWillUnmount() {
    this.is_mounted = false;
  }

  render() {
    if (this.state.loading) return <Loading />;
    if (this.state.error)
      return <EmptyStateMessage text="There was an error loading Volunteer table data. Please try again later" />;

    return (
      <IsMobileProvider isMobile={this.props.isMobile}>
        <VolunteersStatsTableController lastUpdatedAt={this.state.last_updated_at} {...this.props} />
      </IsMobileProvider>
    );
  }
}

export default WithPromises(VolunteerStatsTableWrapper);
